import { useCallback, useEffect, useState } from 'react';
import useBoundStore from 'store';
import PolygonItemsYmap from './PolygonItems';
import { MarketTypes } from 'api/types';
import styles from './styles.module.scss';
import Button from 'components/button';
import { IPolygonItemRequest } from 'api/hooks/use-apartments-limits-secondary';
export interface IPolygonItem {
  id: number;
  name: string;
  coordinates: {
    lat: number;
    lon: number;
  }[];
  color: string;
}

export interface IPolygonTransform extends IPolygonItem {
  isPlaceMarck?: boolean;
  content?: number;
}

const ChooseMapPolygon: React.FC<{ type: MarketTypes; polygonItems: IPolygonItemRequest[] }> = ({
  type,
  polygonItems,
}) => {
  const polygonItemsCorrect = (function () {
    return polygonItems?.map((itemData) => {
      return {
        ...itemData,
        coordinates: itemData.coordinates.map((coord) => ({
          lat: coord.latitude,
          lon: coord.longitude,
        })),
      };
    });
  })();

  const isPrimary = type === MarketTypes.PRIMARY;

  const [selectedPolygonIds, setSelectedPolygonIds] = useState<number[] | null>(null);

  const selectedPolygonPrimary = useBoundStore((s) => s.selectedPolygon);
  const selectedPolygonSecondary = useBoundStore((s) => s.selectedPolygonSecondary);

  const [isRerenderMap, setIsRerenderMap] = useState(true);

  /// спорный момент насчет монтирования данных, вдргу не успеют загрузится из стора тогда точки не отобразятся на полигоне.
  useEffect(() => {
    if (isPrimary && selectedPolygonPrimary) {
      setSelectedPolygonIds(selectedPolygonPrimary?.map((polygonItems) => polygonItems.id));
    } else if (selectedPolygonSecondary) {
      setSelectedPolygonIds(selectedPolygonSecondary?.map((polygonItems) => polygonItems.id));
    } else {
      setSelectedPolygonIds([]);
    }
  }, [type]);

  const setSelectedPolygonPrimary = useBoundStore((s) => s.setSelectedPolygon);
  const setSelectedPolygonSecondary = useBoundStore((s) => s.setSelectedPolygonSecondary);

  const handlePolygon = () => {
    const selectedPolygon = polygonItemsCorrect
      .filter((polygon) => {
        return selectedPolygonIds && selectedPolygonIds.includes(polygon.id);
      })
      .map((polygon) => {
        return {
          id: polygon.id,
          coords: polygon.coordinates.map((coord) => ({
            latitude: coord.lat,
            longitude: coord.lon,
          })),
        };
      });

    isPrimary
      ? setSelectedPolygonPrimary(selectedPolygon)
      : setSelectedPolygonSecondary(selectedPolygon);
  };

  const handleSelectPolygon = useCallback((polygonIds: number[]) => {
    setSelectedPolygonIds((prev) => [...polygonIds]);
  }, []);

  const handleResetPolygon = () => {
    setSelectedPolygonIds([]);
    handleUnLockRenderMap();
  };

  useEffect(() => {
    if (selectedPolygonIds) {
      handlePolygon();
    }
  }, [selectedPolygonIds]);

  const handleLockRenderMap = useCallback(() => {
    setIsRerenderMap(false);
  }, []);

  const handleUnLockRenderMap = useCallback(() => {
    setIsRerenderMap(true);
  }, []);

  const transformedPolygonItems: IPolygonTransform[] = (function () {
    if (selectedPolygonIds) {
      let counter = 0;
      if (polygonItemsCorrect) {
        return polygonItemsCorrect.map((polygon) => {
          if (selectedPolygonIds.includes(polygon.id)) {
            counter++;
            return { ...polygon, isPlaceMarck: true, content: counter };
          }
          return polygon;
        });
      }
    }
    return [];
  })();

  const getLabels = () => {
    const polygons = polygonItems.filter((polygon) => {
      return selectedPolygonIds?.includes(polygon.id);
    });

    return (
      <ul className={styles.chooseMapPolygon__ul}>
        {polygons.map((polygon, index) => {
          return (
            <li className={styles.chooseMapPolygon__li}>
              <div className={styles.chooseMapPolygon__row}>
                <div
                  className={styles.chooseMapPolygon__numb}
                  style={{ background: polygon.color }}
                >
                  <span>{index + 1}</span>
                </div>

                <span style={{ textAlign: 'right' }}>{polygon.name}</span>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles.chooseMapPolygon__container}>
      {selectedPolygonIds && selectedPolygonIds.length > 0 && (
        <div className={styles.chooseMapPolygon__list}>
          {getLabels()}
          <div className={styles.chooseMapPolygon__button}>
            <Button label='Очистить' variant='map' onClick={handleResetPolygon} />
          </div>
        </div>
      )}
      {selectedPolygonIds && (
        <PolygonItemsYmap
          selectedPolygonIds={selectedPolygonIds}
          transformedPolygonItems={transformedPolygonItems}
          isRerenderMap={isRerenderMap}
          onPolygonClick={handleSelectPolygon}
          onLockRenderMap={handleLockRenderMap}
        />
      )}
    </div>
  );
};

export default ChooseMapPolygon;
